<template>
	<div class="personal_header tc">
		<div class="w1200">
			<div class="personal_header_img" v-if="JSON.stringify(myInfo) != '{}'">
				<img :src="myInfo.avatar" class="radius personal_header_tx" />
				<div class="personal_header_vip_grade bg_white tc cl_violet" v-if="myInfo.level_id != 0">{{myInfo.level.name}}</div>
			</div>
			<p class="f20px cl_white mat30">
				<span class="f16px">你好，</span>
				<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) < 0">{{myInfo.real_name}}</span>
				<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) > 0 && [null,''].indexOf(myInfo.name) < 0">{{myInfo.name}}</span>
				<span class="f16px" v-if="[null,''].indexOf(myInfo.real_name) > 0 && [null,''].indexOf(myInfo.name) > 0">{{myInfo.wx_nickname}}</span>
			</p>
			<router-link to="/vip_code"  class="cl_yel inline mat15 personal_header_open" v-if="myInfo.level_id == 0 || myInfo.level_id == null">开通会员 ></router-link>
			<div class="personal_header_r flex">
				<p class="f16px cl_white">账户余额：&nbsp;<span class="f26px">{{myInfo.balance}}</span></p>
				<router-link to="/payment" class="cl_white tc">去充值</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'personal_header',
	  props: {
	    myInfo: {},
	  },
		data () {
			return {
				
			}
		},
		mounted() {
			
		},
		created() {
			
		},
		methods: {
			
		},
	}
</script>

<style>
</style>
